import * as msal from "@azure/msal-browser";
import { msalInstance } from "vue-msal-browser";

export default async function msGraphAuthHeader() {
  let account = msalInstance.getActiveAccount();

  if (account) {
    const silentRequest = {
      account,
      scopes: JSON.parse(process.env.VUE_APP_MS_SCOPES),
    };
    let graphTokenResponse = await msalInstance
      .acquireTokenSilent(silentRequest)
      .catch(error => {
        if (error instanceof msal.InteractionRequiredAuthError) {
          msalInstance.acquireTokenPopup(silentRequest);
        }
      });
    console.log(graphTokenResponse);

    return graphTokenResponse;
  }
}
